import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { MapComponent } from "./map/map.component";
import { ThreedComponent } from "./threed/threed.component";
import { PreparedComponent } from "./prepared/prepared.component";
import { AboutComponent } from "./about/about.component";
import { APP_BASE_HREF } from "@angular/common";
import { SortablejsModule } from "ngx-sortablejs";

const routes: Routes = [
  { path: "map", component: MapComponent },
  { path: "threed", component: ThreedComponent },
  { path: "prepared", component: PreparedComponent },
  { path: "about", component: AboutComponent },
  { path: "**", redirectTo: "/map", pathMatch: "full" }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    SortablejsModule.forRoot({ animation: 150 })
  ],
  exports: [RouterModule],
  providers: [{ provide: APP_BASE_HREF, useValue: "/" }]
})
export class AppRoutingModule {}
